module.exports = "<div [hidden]=\"!stackBar\"><canvas id=\"stackBar\"></canvas></div>\n"